module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-osago-d9ab85c55b9ac9005f09c581aadfc3e4.png";